/* eslint-disable @typescript-eslint/no-explicit-any */
import {DefaultTheme, Interpolation, ThemeProps} from 'styled-components'
import normalizeBreakpointsArray from './normalizeBreakpointsArray'

export type ExpandVariants = (
  variant: undefined | string | null | Array<string | null | undefined>,
  themeObject: Record<string, unknown>,
) => (props: ThemeProps<DefaultTheme>) => Interpolation<any> | null

const expandVariants: ExpandVariants = (variant, themeObject) => ({theme}) => {
  if (!variant) {
    return null
  }

  if (Array.isArray(variant)) {
    const normalizedValue = normalizeBreakpointsArray(variant, theme) as string[]

    return normalizedValue
      .map((v, i) => {
        if (v && themeObject[v]) {
          return theme.normalizeStyles(themeObject[v], theme.viewportsArray[i])
        }
        return false
      })
      .filter(Boolean)
  } else if (themeObject[variant]) {
    return theme.normalizeStyles(themeObject[variant])
  }

  return null
}

export default expandVariants
